export default {
  id: 'AnnouncementModal',
  code: 'CN',
  text: {
    'Announcement Content': '公告内容',
    'For': '公告对象',
    'Title': '公告标题',
    'All': '全体师生',
    'Please select announcement target': '请选择公告对象',
    'Please enter announcement title': '请输入公告标题',
    'Please enter announcement content': '请输入公告内容',
    'Content': '公告内容',
    'Publish': '发布',
    'Save': '保存为草稿',
    'All Fields with * Must Be Filled': '带*号的字段必须填写',
    '': '',
  }
}



// WEBPACK FOOTER //
// ./src/template/Modals/Announcement/locale.js